export default __webpack_public_path__ + "static/media/miguel-lopes-16.7667fa39.jpg";